/**
 * This warning is if a user tries to make a trade (as a market order), and we detect his qty is larger than the current bid ask. 
 * Bc of horror stories related to trading thin instruments, we adjust his market order to a limit order with a limit price
 * a bit above/below the current price
 *{
	"messageType": "alertNotification",
	"notificationId": 1645460595010,
	"notificationDetails": {"warningType":"LIQUIDITY_WARNING","notificationType":"WARNING","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ORDER_LIQUIDITY_WARNING",
	"statusDetails": {"bidAskSize":5.0,"orderQty":22.0,"limitPriceChange":0.1,"positionSymbol":"XYZ","adjustedLimitPrice":1.1},
	"date": "2022-02-21T11:23:15.886-0500",
	"timestamp": "1645460595886"
}

 * @param {*} statusDetails 
 * @returns object containing following fields...
 * 1) bidAskSize: the bid ask size that we have detected for the instrument/symbol behind traded.
 * 
 * 2) orderQty: the qty of the user's order.
 * 
 * 3) limitPriceChange: how much $$ (default $0.10 I believe) are we adding to the current price when calculating the limit price.
 * 
 * 4) symbol: the symbol the user is trying to trade.
 * 
 * 5) adjustedLimitPrice: the limit price we have placed the order at
 */
export function liquidtyWarningParser(statusDetails) {
  const parsedObj = {
    bidAskSize: null,
    orderQty: null,
    limitPriceChange: null,
    symbol: null,
    adjustedLimitPrice: null,
  };
  if (statusDetails) {
    parsedObj.bidAskSize = statusDetails.bidAskSize ?? null;
    parsedObj.orderQty = statusDetails.orderQty ?? null;
    parsedObj.limitPriceChange = statusDetails.limitPriceChange ?? null;
    parsedObj.symbol = statusDetails.positionSymbol ?? null;
    parsedObj.adjustedLimitPrice = statusDetails.adjustedLimitPrice ?? null;
  }

  return parsedObj;
}
